import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable()
export class CoalService {
  headers: HttpHeaders;
  url: string;
  urlHost: string;
  urlsparrow: string;
  urlPayments: string;
  constructor(private http: HttpClient, private baseService: BaseService) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.url = environment.serviceUrl;
    this.urlHost = environment.hostBack;
    this.urlsparrow = environment.sparrowreport;
    this.urlPayments = environment.payments;
  }

  getService(ruta: string, headers?: HttpHeaders) {
    if (headers) { this.headers = headers; }
    const dataUser = this.baseService.getUserData();
    let rutaId = ruta//( ruta.indexOf('?') == -1 ) ? ruta + '?idUsuario=' + dataUser.user.idUsuario : ruta + '&idUsuario=' + dataUser.user.idUsuario;

    return this.http.get(this.url + rutaId, { headers: this.headers });
  }

  postService(ruta: string, body?: any, headers?: HttpHeaders) {
    // get getUserData from base.service and save in var dataUser
    const dataUser = this.baseService.getUserData();

    let params = null;
    // if( dataUser === null ){
    params = {
      ...body
    }
    // }
    // else{
    //   params = {
    //     ...body,
    //     idUsuario: dataUser.user.idUsuario
    //   }
    // }


    if (headers) { this.headers = headers; }
    return this.http.post(this.url + ruta, params, { headers: this.headers });
  }

  putService(ruta: string, body?: any, headers?: HttpHeaders) {
    if (headers) { this.headers = headers; }
    return this.http.put(this.url + ruta, body, { headers: this.headers });
  }

  deleteService(ruta: string, headers?: HttpHeaders) {
    if (headers) { this.headers = headers; }
    return this.http.delete(this.url + ruta, { headers: this.headers });
  }


  // deleteService(ruta: string, data: any, headers?: HttpHeaders) {
  //   if (headers) { this.headers = headers; }
  //   return this.http.delete(this.url + ruta + data, { headers: this.headers });
  //     //+ '?' + data, { headers: this.headers });
  // }

  postServiceFile(ruta: string, body?: any, headers?: any) {
    //console.log(this.urlsparrow + ruta);
    // return this.http.post(this.urlsparrow + ruta, body, { responseType: "arraybuffer" });
    return this.http.post(this.url + ruta, body);
  }
  postServiceBuffer(ruta: string, body?: any, headers?: any) {
    //console.log(this.urlsparrow + ruta);
    // return this.http.post(this.urlsparrow + ruta, body, { responseType: "arraybuffer" });
    return this.http.post(this.url + ruta, body, { responseType: "arraybuffer" });
  }
  postServiceSparrow(ruta: string, body?: any, headers?: HttpHeaders) {
    return this.http.post(this.urlsparrow + ruta, body, { responseType: "arraybuffer" });
  }
  postServicePayments(ruta: string, body?: any, headers?: HttpHeaders) {
    return this.http.post(this.urlPayments + ruta, body, { headers: this.headers });
  }
  uploadFile(ruta: string, file: File, folder: string = null): Observable<HttpEvent<any>> {

    const formData = new FormData();
    formData.append(`files`, file);
    if (folder)
      formData.append(`fileInfo`, `{"name":"${file.name}","folder":"${folder}"}`);

    // Strapi upload plugin uses /upload without /api prefix
    const req = new HttpRequest('POST', this.urlHost + '/' + ruta, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }
}
